import { connect } from "react-redux";
import { IPlayUIStateProps } from "../../../..";
import {
  triggerMuteChangeRequest,
  triggerVolumeChangeRequest
} from "../../../Common/Keypad.actions";
import { SoundButtonView } from "./SoundButton.view";

const mapStateToProps = (state: IPlayUIStateProps) => {
  return {
    soundButtonDisabled: state.keypad.soundButtonDisabled,
    muted: state.keypad.muted,
    volume: state.keypad.volume
  };
};

const mapDispatchToProps = dispatch => {
  return {
    triggerVolumeChangeRequest: value =>
      dispatch(triggerVolumeChangeRequest(value)),
    triggerMuteChangeRequest: value => () =>
      dispatch(triggerMuteChangeRequest(value))
  };
};

export const SoundButton: any = connect(
  mapStateToProps,
  mapDispatchToProps
)(SoundButtonView);
